import { useEffect } from 'react';
import { useAppSelector } from '../../../core/redux/hooks/useAppSelector';
import { selectGameType, selectResult, selectStarted } from '../selectors';
import { postMessageToParent } from '../../../shared/utils';

export const useGameEvents = () => {
  const gameStarted = useAppSelector(selectStarted);
  const gameResult = useAppSelector(selectResult);
  const gameType = useAppSelector(selectGameType);

  useEffect(() => {
    if (gameStarted) {
      postMessageToParent({ type: 'gameStart', gameType });
    }
  }, [gameStarted, gameType]);

  useEffect(() => {
    if (gameResult !== null) {
      postMessageToParent({ type: 'gameEnd', gameType, result: gameResult });
    }
  }, [gameResult, gameType]);
};
